export default [
    "Information",
    "Separate"
]